import $ from 'jquery';
import React,{useState,useEffect} from 'react';
import {GetImgCertUser_CBack,btnSetColor_CBack,TableDatePicker} from '../function_lib/common_lib';

export function updAddDeductBalance(){
    GetImgCertUser_CBack(this,"#frmApproveBalance","approveTransqRequest",function(checkData,checkMsg,userMsg){
      if(checkData===-10){
        alert("Kindly fill required fields");
        return;
      }else {
        //Custom_Alert("Successfully Added",checkMsg,false);
        alert(checkMsg);
        $('#approveTransqRequest').modal('hide');
        window.location.reload();
      }
    });
}             
  
export const Comp_Approve_Balance=(props)=>{
    
    useEffect(()=>{
        //setMyProfile(props.memberProfile);
        //alert(JSON.stringify(props.memberProfile));
    },[props.memberProfile])

    //alert(JSON.stringify(props));
        return(<div className="modal fade bd-example-modal-xl"  id="divApproveBalance" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
          <div className="modal-header bg-primary">
              <h5 className="modal-title text-white" id="exampleModalLabel">Add / Deduct Balance</h5>
              <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" className="text-white">&times;</span>
              </button>
            </div>
            <div className="modal-body">
            {props.memberProfile.length>0?
            <form enctype="multipart/form-data" method="POST" onsubmit="event.preventDefault()" className="contact-form-style form-control11 " name="frmApproveBalance" id="frmApproveBalance">
    <input type="hidden" name="curl_type" id="curl_type" value="approveTransqRequest" />  
                <input type="hidden" name="m_type" id="m_type" value="approveTransqRequest" />
                <input type="hidden" name="res_func" id="res_func" value="okSuccCont" />
                <input type="hidden" name="account_info_id" id="account_info_id"  value={btoa(props.memberProfile[0]["account_info_id"])}/>
                <input type='hidden' name="member_token" id="member_token" value={btoa(props.memberProfile[0]["id"])}/>
                <input type="hidden" name="local_token" id="local_token" value={props.logInObj[0]["id"]}/>
        {/* uneditable Information */}
        <div class="row">
        <div class="col-md-4 form-group pl-2 pr-2 mb-4">
                <label class="float-left">Member ID:<strong> {props.memberProfile[0]["id"]}</strong> </label>
                
            </div>
        <div class="col-md-4 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Company Name: {props.memberProfile[0]["company_name"]}</strong></label>
            </div>

            <div class="col-md-4 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Person Name: {props.memberProfile[0]["person_name"]}</strong></label>
            </div>

            <div class="col-md-4 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Contact No:</strong> {props.memberProfile[0]["contact_no"]}</label>
            </div>
            <div class="col-md-4 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Email-Id:</strong> {props.memberProfile[0]["email_id"]}</label>
            </div>

            <div class="col-md-4 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Available Balance:</strong> {props.memberProfile[0]["email_id"]}</label>
            </div>

        </div>
        <h4 class="mt-4">Under Pending Approval Details</h4>
        <div class="row">
           
          
            <div class="col-md-3 col-sm-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Paid Amount:</strong>{props.memberProfile[0]["balance"]}</label>
               

                
            </div>
            <div class="col-md-3 col-sm-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Payment Mode:</strong>{props.memberProfile[0]["payment_mode"]}</label>
               
                
            </div>

            <div class="col-md-3 col-sm-6 pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Narration (Remarks*):</strong></label>
            <span>{props.memberProfile[0]["narration"]}</span>
        </div>

        <div class="col-md-3 col-sm-6 pl-2 pr-2 mb-4">
            <label class="float-left"><strong>UTR/Transaction-Id (if Any)::</strong></label>
            <span>{props.memberProfile[0]["utr_trans_id"]}</span>
        </div>
           
        </div>
    
      

        <div class="form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Approve/Reject</strong></label>
            Authorized personel should cross check transaction properly before approval  
            <select className='form-control required' id="status" name="status">
                    <option value={"0"}>-Approve/Reject-</option>
                    <option value={"Approved"}>Approved</option>
                    <option value={"Reject"}>Reject</option>
                </select>
        </div>
       
        <div class="text-center mt-4">
            <button type="button" onClick={()=>updAddDeductBalance()} class="float-left btn btn-primary me-2">Update</button>
            {/* <button type="reset" class="btn btn-secondary">Reset</button> */}
        </div>
    </form>:''}
          </div>
          </div>
          </div>
          </div>);
    
}
export default Comp_Approve_Balance;
